import { translateDomain } from '../../../utils/labels_utils';

export const tableHeader = (t) => [
  { id: "scfId", type: "text", label: t('company:complianceProgram.show.table.controlCode'), sortable: true },
  { id: "scfControl", type: "text", label: t('company:complianceProgram.show.table.control'), sortable: true },
  {
    id: "scfDomain",
    type: "dropdown",
    label: t('company:complianceProgram.show.table.domain'),
    sortable: true,
    format: (v) => (v ? translateDomain(t, v) : ''),
  },
  { id: "controlWeighting", type: "number", label: t('company:complianceProgram.show.table.weight'), sortable: true },
  { id: "vinculado", type: "boolean", label: t('company:complianceProgram.show.table.bond'), sortable: true },
  { id: "actions-add", type: "actions-add", label: "" },
];
